import React from 'react';
import UpdateLayout, { ExternalLink } from './UpdateLayout';
import { OSSIE_SOURCES, DELIVERY_CONTEXT } from '../../../content/snowflakeUpdates';

export default function OssiePost() {
  return (
    <UpdateLayout
      path="/updates/ossie-semantic-view-interchange"
      title="Ossie and semantic view interchange"
      sources={OSSIE_SOURCES}
    >
      <p>
        Apache Ossie (Incubating) is an open specification for a semantic model that more than one
        tool can read. Snowflake can import that YAML into a semantic view, and it can export a
        semantic view back out. Both directions are in preview.
      </p>
      <p>
        On July 10, 2026, the project entered the Apache Incubator under this name. The specification
        did not change with the rename (
        <ExternalLink href="https://ossie.apache.org/updates/ossie-enters-apache-incubator/">
          Apache Ossie announcement
        </ExternalLink>
        ).
      </p>
      <p>
        Import uses SYSTEM$CREATE_SEMANTIC_VIEW_FROM_OSSIE_YAML. Export uses
        SYSTEM$READ_OSSIE_YAML_FROM_SEMANTIC_VIEW. The create procedure accepts specification version
        0.1.1. It reads a SNOWFLAKE dialect expression first and falls back to ANSI_SQL. A field or
        metric that only has another dialect is skipped, without an error. Metadata Snowflake does
        not model natively, including custom extensions, is kept on the view (
        <ExternalLink href="https://docs.snowflake.com/en/sql-reference/stored-procedures/system_create_semantic_view_from_ossie_yaml">
          create procedure
        </ExternalLink>
        ,{' '}
        <ExternalLink href="https://docs.snowflake.com/en/sql-reference/functions/system_read_ossie_yaml_from_semantic_view">
          read function
        </ExternalLink>
        ).
      </p>
      <p>
        There is no dated 2026 release note for these two procedures in the feature index. The
        procedure pages are the source for the version they accept and for how expressions are
        chosen. The October 14 brief and the behavior-change notes both still mark the interchange
        as preview.
      </p>

      <h2 className="pt-2 font-display text-2xl font-semibold tracking-tight text-brand-900">
        What this means for your team
      </h2>
      <p>
        If a semantic view needs to move to or from another tool, Ossie is the interchange format,
        and it is still preview. Semantic Studio remains the authoring surface inside Snowflake.
        Treat an export as a file you review. A vendor-specific expression that is not Snowflake SQL
        or ANSI SQL does not come across. {DELIVERY_CONTEXT}
      </p>
    </UpdateLayout>
  );
}
